import angular from 'angular';

import component from './icon-label-value.component';

const IconLabelValue = angular
    .module('control-room.commons.basic.components.icon-label-value', [])
    .component('crIconLabelValue', component);

export default IconLabelValue;
